export const LocalityAbbr = {
  "город": `г.`,
  "посёлок": `п.`
};
export const CLOSE_BUTTON_TEXT = `Закрыть`;
export const MODAL_HEADING = `Выбор города`;
export const MODAL_INPUT_PLACEHOLDER = `Поиск города`;
export const SEARCH_TEXT = `Поиск`;
